import React from "react";

const sortCaret = (order) => {
  let caretClass = "ml-1 text-[9px] text-white cursor-pointer";
  if (!order) return <span className={caretClass}>▲▼</span>;
  return order === "asc" ? (
    <span className={caretClass}>▲</span>
  ) : (
    <span className={caretClass}>▼</span>
  );
};

export default sortCaret;
